<form [formGroup]="form" (ngSubmit)="btnPesquisar()">
  <div class="card">
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-12 col-sm-12 col-md-6 col-lg-6">
          <lib-autocomplete [schema]="nomeSchema"></lib-autocomplete>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-6">
          <lib-autocomplete [schema]="nomeCompletoSchema"></lib-autocomplete>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-md-3 col-lg-3">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Ativa enquadramento</mat-label>
            <mat-select [formControlName]="'ativa'" [formGroup]="form">
              <mat-option [value]="null"></mat-option>
              <mat-option
                *ngFor="let opcao of opcoesAtivaEnquadramento"
                [value]="opcao.id"
                >{{ opcao.text }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-6 col-md-3 col-lg-3">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Processamento automático</mat-label>
            <mat-select [formControlName]="'auto'" [formGroup]="form">
              <mat-option [value]="null"></mat-option>
              <mat-option
                *ngFor="let opcao of opcoesProcAuto"
                [value]="opcao.id"
                >{{ opcao.text }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="card-footer d-flex flex-row justify-content-end">
      <div class="pr-3">
        <button
          mat-raised-button
          color="primary"
          [disabled]="form.invalid || (loading$ | async)"
          label="Pesquisar"
          type="submit"
          title="Pesquisar"
        >
          <loading-icon
            [btnLabel]="'Pesquisar'"
            [loading]="loading$ | async"
          ></loading-icon>
        </button>
      </div>
      <div class="">
        <button mat-raised-button
                [matMenuTriggerFor]="menuExportarAssociacao"
                [disabled]="(loadingExport$ | async) || !showExecutar">
          <loading-icon
            [btnLabel]="'Exportar'"
            [loading]="loadingExport$ | async"
          ></loading-icon> <span class="caret"></span>
        </button>
        <mat-menu #menuExportarAssociacao="matMenu">
          <button mat-menu-item (click)="exportarPdf()">
            <span>PDF</span>
          </button>
          <button mat-menu-item (click)="exportarXls()">
            <span>Excel</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</form>
